<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="84.578"
    height="361.99"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 84.578 361.99"
    :class="tester"
  >
    <path
      d="M3.195 3.193c7.493 112.223 27.82 241.368 77.434 354.847"
      fill="none"
      stroke="#ffdf22"
      stroke-linecap="round"
      stroke-width="6"
      stroke-dasharray="20"
    />
  </svg>
</template>
<script>
export default {
  props: ['tester'],
};
</script>
